import React, { useState } from 'react';
import axios from 'axios';

const EditNewsModal = ({ newsItem, onClose, onUpdate }) => {
    const [title, setTitle] = useState(newsItem.title);
    const [content, setContent] = useState(newsItem.content);
    const [image, setImage] = useState(null);
    const [uploading, setUploading] = useState(false);

    // Функция загрузки изображения на сервер
    const handleImageUpload = async () => {
        if (!image) return newsItem.imageUrl; // Если изображение не выбрано, используем старое

        setUploading(true);
        const formData = new FormData();
        formData.append('image', image);

        try {
            const response = await axios.post('https://api.alertapp.kz/api/v1/upload', formData, {
                headers: { 'Content-Type': 'multipart/form-data' }
            });
            return response.data.imageUrl; // Вернем новый URL изображения
        } catch (error) {
            console.error("Ошибка загрузки изображения:", error);
            return newsItem.imageUrl; // Вернем старый URL при ошибке
        } finally {
            setUploading(false);
        }
    };

    // Функция обновления новости
    const handleUpdate = async () => {
        const imageUrl = await handleImageUpload(); // Загружаем изображение перед обновлением

        const updatedData = { title, content, imageUrl };

        axios.put(`hgit ttps://api.alertapp.kz/api/v1/news/${newsItem._id}`, updatedData, {
            headers: { 'Content-Type': 'application/json' }
        })
            .then(response => {
                onUpdate(response.data);
                onClose();
                window.location.reload();
            })
            .catch(error => console.error('Ошибка обновления новости:', error));
    };

    return (
        <div className="modal">
            <div className="modal-content">
                <button onClick={onClose}>×</button>
                <h2>Редактировать новость</h2>
                <input type="text" placeholder="Заголовок" value={title} onChange={(e) => setTitle(e.target.value)} />
                <textarea placeholder="Содержание" value={content} onChange={(e) => setContent(e.target.value)} />
                <input type="file" onChange={(e) => setImage(e.target.files[0])} />
                <button onClick={handleUpdate} disabled={uploading}>{uploading ? 'Загрузка...' : 'Сохранить'}</button>
            </div>
        </div>
    );
};

export default EditNewsModal;
